import * as React from 'react';

export const RefreshIcon = () => (
  // eslint-disable-next-line react/forbid-elements
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
    {/* tslint:disable-next-line:max-line-length */}
    <path
      fillRule="nonzero"
      d="M1.615 7H0c0-3.877 3.123-7 7-7 1.777 0 3.446.7 4.685 1.777L13.462 0c.323 0 .538.215.538.538v4.308c0 .323-.215.539-.538.539H9.154c-.323 0-.539-.216-.539-.539L10.5 2.962C9.585 2.1 8.346 1.615 7 1.615 4.038 1.615 1.615 4.038 1.615 7zM7 12.385c-1.346 0-2.585-.485-3.5-1.347l1.885-1.884c0-.323-.216-.539-.539-.539H.538c-.323 0-.538.216-.538.539v4.308c0 .323.215.538.538.538l1.777-1.777C3.554 13.353 5.17 14 7 14c3.877 0 7-3.123 7-7h-1.615c0 2.962-2.423 5.385-5.385 5.385z"
    />
  </svg>
);
